<div class="container">
<div class="mt-4">
  <data-table
    title="Equipos alquiler"
    [columns]="columnasInventoryEquipment"
    [url]='urlTableInventoryEquipment'
    [configuration]="configurationInentoryEquipment"
    [reloadTable]="reloadTableInventoryEquipment"
    [params]="[]"
    [headerFilters]="headerFilters"
    (edit)="editCost($event)">
  </data-table>
</div>
</div>
